<script lang="ts" setup>
import { useCityStore } from '@/store/city/city'
import type { FooterLink } from '@/store/city/city.types'

import { IconsKeys } from '@smenaspace/ui-layer/types'

type Link = {
  name: string
  path: string
  icon?: IconsKeys
  isHighlight?: boolean
}

const { findLinkByName } = useCityStore()

const jobsLink: FooterLink | undefined = findLinkByName('Вакансии') || undefined

const routerLinks: Link[] = [
  {
    name: 'Акции',
    path: '/sales/',
    icon: 'fill-flash',
    isHighlight: true,
  },
  {
    name: 'Наши рестораны',
    path: '/delivery/',
  },
  {
    name: 'Бонусы',
    path: '/bonus/',
  },
  {
    name: 'Оплата',
    path: '/payment/',
  },
]
</script>

<template>
  <div class="header-bottom-links">
    <a
      href="https://farfor.ru/a/"
      class="header-bottom-links__link header-bottom-links__link--highlight"
      rel="nofollow"
    >
      <the-icon name="fill-smartphone" color="var(--ui-color-primary)" />

      Приложение Farfor
    </a>

    <nuxt-link
      v-for="link in routerLinks"
      :key="link.path"
      :prefetch="false"
      :to="link.path"
      class="header-bottom-links__link"
      :class="{ 'header-bottom-links__link--highlight': link.isHighlight }"
    >
      <the-icon
        v-if="link.icon"
        :name="link.icon"
        color="var(--ui-color-primary)"
      />
      {{ link.name }}
    </nuxt-link>

    <a
      href="https://farfor.ru/control/"
      rel="nofollow"
      class="header-bottom-links__link"
    >
      Тайный покупатель
    </a>

    <a
      v-if="jobsLink"
      :href="jobsLink.link"
      class="header-bottom-links__link"
      rel="nofollow"
    >
      Работа в Farfor
    </a>

    <a
      href="https://farfor.ru/partner/"
      class="header-bottom-links__link"
      rel="nofollow"
    >
      Франшиза
    </a>
  </div>
</template>

<style lang="scss" scoped>
.header-bottom-links {
  display: flex;
  gap: 32px;
  align-items: center;
  height: 100%;
  padding: 11px 24px;

  @include media('>=desktop') {
    max-width: 1200px;
    padding: 11px 0;
    margin: 0 auto;
  }

  &__link {
    display: flex;
    gap: 4px;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    color: var(--ui-text-primary);

    &--highlight {
      font-weight: 800;
      color: var(--ui-color-primary);
    }
  }
}
</style>
